import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import clsx from "clsx";
import styles from "./TransactionDetails.module.css";

const TransactionDetailsLoadingSkeleton = () => {
  return (
    <div className={styles.detailWrapper}>
      <h2 className={styles.detailTitle}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={6}
            rounding="sm"
            extraClasses={styles["title-loader"]}
          />
        </span>
      </h2>

      <div className={styles.detailRow}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
      </div>

      <div className={styles.detailRow}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader-shorter"]}
          />
        </span>
      </div>

      <div className={styles.detailRow}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
      </div>

      <div className={clsx(styles.detailRow, styles.withDivider)}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
        <div className={styles.valueWithCopy}>
          <span>
            <SkeletonLoader
              variant="rectangular"
              height={5}
              rounding="sm"
              extraClasses={styles["text-loader"]}
            />
          </span>
          <span>
            <SkeletonLoader
              variant="circular"
              height={5}
              extraClasses={styles["text-loader-round"]}
            />
          </span>
        </div>
      </div>

      <div className={styles.detailRow}>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader"]}
          />
        </span>
        <span>
          <SkeletonLoader
            variant="rectangular"
            height={5}
            rounding="sm"
            extraClasses={styles["text-loader-longer"]}
          />
        </span>
      </div>
    </div>
  );
};

export default TransactionDetailsLoadingSkeleton;
